import "core-js/modules/es.array.some.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.some.js";
import { request } from '@libs';
/**
 * https://docs.corp.kuaishou.com/d/home/fcABfChjIn1zsbQyaBURUjGwd
 */

export var EEventId = /*#__PURE__*/function (EEventId) {
  EEventId["CREATE_TEST_PLAN"] = "10051";
  EEventId["RELATE_TEST_CASE"] = "10052";
  EEventId["START_PLAN_REVIEW"] = "10053";
  EEventId["PLAN_REVIEW_PASSED"] = "10054";
  return EEventId;
}({});
export var EPoint = /*#__PURE__*/function (EPoint) {
  return EPoint;
}({});
export function loadHasTeamFields(params) {
  return request.post('/api/atlas/plans/review/popupCheck', params).then(function (result) {
    if (result.list && result.list.length > 0) {
      return result.list.some(function (item) {
        return item.popup;
      });
    }
    return false;
  })["catch"](function (e) {
    // 当依赖的下有方服务挂了，为了不卡住流程，直接跳过必填弹窗
    return false;
  });
}